import React, { useEffect, useState } from 'react';

export const Tooltip = ({
  delay,
  children,
  content,
  direction = 'top',
  tipClass = 'utm'
}) => {
  let timeout;
  const [active, setActive] = useState(false);

  const showTip = () =>
    (timeout = setTimeout(() => setActive(true), delay || 400));

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  useEffect(() => () => clearTimeout(timeout));

  return (
    <div
      className={`${tipClass}__tooltip-wrapper`}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {children}
      {active && (
        <div
          className={`${tipClass}__tooltip-tip  ${`${tipClass}__tooltip-tip--${direction}`}`}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
